import script from "./MrdValidationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MrdValidationSection.vue?vue&type=script&setup=true&lang=js"

import "./MrdValidationSection.vue?vue&type=style&index=0&id=540a279a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540a279a"]])

export default __exports__